import { SettingsBase } from './SettingsBase';

export class SpeakerSettings extends SettingsBase {
    static NAME_OF_CLASS = 'SpeakerSettings';
    public SpeakerItems: SpeakerItemSettings[] = [];

    public constructor(val?: SpeakerSettings) {
        super();
        this.SpeakerItems = val?.SpeakerItems ?? [];
    }
}

export class SpeakerItemSettings {
    public CategoryID: number | 'total' | 'male' | 'female' | null = null;

    /**
     * A list of station roles we should show in the table. empty array means we show all station roles
     */
    public StationRoleIDs: number[] = [];

    public RaceID: number | null = null;

    /**
     * If we want to show DNX in the tables
     */
    public ShowDNX: boolean = false;

    /**
     * If we want to show the trend in the tables, this is only used for the total category, since the trend is based on the total results
     */
    public ShowTrend: boolean = false;

    public constructor(val?: SpeakerItemSettings) {
        this.CategoryID = val?.CategoryID ?? null;
        this.RaceID = val?.RaceID ?? null;
        this.StationRoleIDs = val?.StationRoleIDs ?? [];

        this.ShowDNX = val?.ShowDNX ?? false;
        this.ShowTrend = val?.ShowTrend ?? false;
    }
}
